import {
  LoyaltyConfig,
  SovendusConfig,
  WebLoyaltyConfig,
} from '@moonpig/web-core-types'

export { getBrandBaseUrl } from './getBrandBaseUrl'
export { createSovendusConfig } from './sovendus'

export const createWebLoyaltyConfig = (id: string): LoyaltyConfig => {
  const UNSUPPORTED_WEB_LOYALTY_CONFIG = getUnsupportedConfig()
  try {
    const loyaltyConfig = process.env.WEB_LOYALTY
    if (!loyaltyConfig) return UNSUPPORTED_WEB_LOYALTY_CONFIG

    return getConfig(id, loyaltyConfig)
  } catch (e) {
    return UNSUPPORTED_WEB_LOYALTY_CONFIG
  }
}

const getConfig = (storeId: string, loyaltyConfig: string): LoyaltyConfig => {
  const unknownConfig: LoyaltyConfig = JSON.parse(loyaltyConfig)[storeId]

  if (isWebLoyaltyConfig(unknownConfig)) {
    return {
      provider: unknownConfig.provider,
      hash: unknownConfig.hash || undefined,
      prodId: unknownConfig.prodId || undefined,
    }
  }

  if (isSovendusConfig(unknownConfig)) {
    return {
      provider: unknownConfig.provider,
      trafficSourceNumber: unknownConfig.trafficSourceNumber || undefined,
      trafficMediumNumber: unknownConfig.trafficMediumNumber || undefined,
    }
  }

  return getUnsupportedConfig()
}

const isWebLoyaltyConfig = (
  config: LoyaltyConfig,
): config is WebLoyaltyConfig => {
  return (
    config &&
    typeof config === 'object' &&
    config.provider === 'WebLoyalty' &&
    typeof config.hash === 'string' &&
    typeof config.prodId === 'string'
  )
}

const isSovendusConfig = (config: LoyaltyConfig): config is SovendusConfig => {
  return (
    config &&
    typeof config === 'object' &&
    config.provider === 'Sovendus' &&
    typeof config.trafficSourceNumber === 'string' &&
    typeof config.trafficMediumNumber === 'string'
  )
}

const getUnsupportedConfig = (): WebLoyaltyConfig => {
  return {
    provider: 'WebLoyalty',
    hash: undefined,
    prodId: undefined,
  }
}
